// extracted by mini-css-extract-plugin
module.exports = {"actions":"provider-actions_actions__3FikM","status":"provider-actions_status__1i7c9"};